import React from "react";
import bankLogos from "assets/img/MyDonation_01.jpg";
import Main from "../../Main";
import DepositUpload from "./DepositUpload";
import MyDonationPaymentsContainer from "./MyDonationPaymentsContainer";
import "./MyDonation.css";
import { Link } from "react-router-dom";

const MyDonation = props => {
    return (
        <Main>
            <div className="island">
                <div className={props.hide === true ? "col-sm-12" : "col-sm-8"}>
                    <h2>Your Payments</h2>

                    <p>
                        Note: Your donations in this portal are updated within
                        two to three weeks after debit date for credit card
                        givers or after receipt of deposit slips or cash. For
                        other changes in your sponsorship, please give us one
                        month to update your sponsorship portal account.
                    </p>

                    <p>
                        For your convenience, you may also shift to auto-giving.
                        Just click{" "}
                        <a href="http://www.worldvision.org.ph/sponsorship-donorcare-step1" rel="noopener noreferrer">
                            here
                        </a>
                        .
                    </p>
                </div>

                <div className={props.hide === true ? "" : "col-sm-4"}>
                    <DepositUpload
                        hide={props.hide}
                        fname={props.fname}
                        submit={props.submit}
                        loading={props.loading}
                        change={props.change}
                    />
                </div>

                <div className="col-sm-12">
                    <MyDonationPaymentsContainer
                        hideDeposit={props.hideDeposit}
                    />

                    <p>
                        <Link to={`/dashboard/faq`}>
                            <img
                                alt=""
                                src={bankLogos}
                                style={{ height: "auto", width: "100%" }}
                            />
                        </Link>
                    </p>
                </div>
            </div>
        </Main>
    );
};

export default MyDonation;
